import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  appBar: {
    background: "#0b80ad",
    borderRadius: 15,
    margin: "30px 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  heading: {
    color: "#fff",
  },
  image: {
    marginLeft: "15px",
  },
}));
